module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0108.jpg?v=9cfbbcde";